import http from '../interceptors/Intercepter';

export const viewQualityControlDashboard = async (username) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const params = {
      username: username,
    };

    const { data } = await http.get('/api/dashboard/view/quality-control', { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const viewDataManagementDashboard = async (username) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const params = {
      username: username,
    };

    const { data } = await http.get('/api/dashboard/view/data-management', { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};
